<template>
	<div v-if="toggleImageChoice">
		<ImageChoice @close-image-choice="closeImageChoice" :lunchId="lunchId" />
	</div>
	<div v-if="toggleEditModal">
		<LunchUpdate @close-lunch-edit="closeEditModal" :lunchId="lunchId" />
	</div>

	<div v-if="lunch" class="py-8">
		<div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
			<div class="flex flex-col md:flex-row -mx-4">
				<div class="md:flex-1 px-4">
					<div class="h-[460px] rounded-lg bg-gray-300 dark:bg-gray-700 mb-4">
						<img
							class="w-full h-full object-cover rounded-xl shadow-lg dark:shadow-slate-800/[.7]"
							:src="lunch.image ? `${media}${lunch.image.filename}` : defaultImage"
							alt="Product Image" />
					</div>
					<div class="flex -mx-2 mb-4">
						<div class="w-1/2 px-2">
							<button
								@click="toggleEditModal = true"
								class="text-gray-100 dark:text-gray-900 inline-flex items-center bg-yellow-500 hover:bg-yellow-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mb mx-1">
								<svg
									class="me-1 -ms-1 w-5 h-5"
									aria-hidden="true"
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24">
									<path
										stroke="currentColor"
										stroke-linecap="round"
										stroke-width="2"
										d="M20 6H10m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H4m16 6h-2m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H4m16 6H10m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H4" />
								</svg>
								Edit
							</button>
						</div>
						<div class="w-1/2 px-2">
							<button
								@click="toggleImageChoice = true"
								class="text-gray-100 dark:text-gray-900 inline-flex items-center bg-purple-500 hover:bg-purple-700 focus:ring-4 focus:outline-none focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mb mx-1">
								<svg
									class="me-1 -ms-1 w-5 h-5"
									aria-hidden="true"
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24">
									<path
										stroke="currentColor"
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="2"
										d="M7 8v8a5 5 0 1 0 10 0V6.5a3.5 3.5 0 1 0-7 0V15a2 2 0 0 0 4 0V8" />
								</svg>
								Attach image
							</button>
						</div>
						<div class="w-1/2 px-2">
							<button
								@click="deleteLunch(lunch.id)"
								class="text-gray-100 dark:text-gray-900 inline-flex items-center bg-red-500 hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mb mx-1">
								<svg
									class="me-1 -ms-1 w-5 h-5"
									aria-hidden="true"
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24">
									<path
										stroke="currentColor"
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="2"
										d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z" />
								</svg>
								Delete
							</button>
						</div>
					</div>
				</div>
				<div class="md:flex-1 px-4">
					<h2 class="text-2xl font-bold text-gray-800 dark:text-white mb-2">{{ lunch.restaurant }}</h2>
					<!-- <p class="text-gray-600 dark:text-gray-300 text-sm mb-4">{{ lunch.message }}</p> -->
					<p class="text-gray-600 dark:text-gray-300 text-sm mb-4">Created: {{ formatDateTime(lunch.created_at) }}</p>
					<p class="text-gray-600 dark:text-gray-300 text-sm mb-4">Updated: {{ formatDateTime(lunch.updated_at) }}</p>
					<div class="flex mb-4 justify-center">
						<div class="mr-4">
							<span class="font-bold text-gray-700 dark:text-gray-300">Is active:</span>
							<span class="text-gray-600 dark:text-gray-300">
								<svg
									v-if="lunch.is_active"
									class="ml-2 w-6 h-6 text-green-500 inline-block"
									aria-hidden="true"
									xmlns="http://www.w3.org/2000/svg"
									fill="currentColor"
									viewBox="0 0 24 24">
									<path
										fill-rule="evenodd"
										d="M2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm13.7-1.3a1 1 0 0 0-1.4-1.4L11 12.6l-1.8-1.8a1 1 0 0 0-1.4 1.4l2.5 2.5c.4.4 1 .4 1.4 0l4-4Z"
										clip-rule="evenodd" />
								</svg>
								<svg
									v-if="!lunch.is_active"
									class="ml-2 w-6 h-6 text-red-500 inline-block"
									aria-hidden="true"
									xmlns="http://www.w3.org/2000/svg"
									fill="currentColor"
									viewBox="0 0 24 24">
									<path
										fill-rule="evenodd"
										d="M2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm7.7-3.7a1 1 0 0 0-1.4 1.4l2.3 2.3-2.3 2.3a1 1 0 1 0 1.4 1.4l2.3-2.3 2.3 2.3a1 1 0 0 0 1.4-1.4L13.4 12l2.3-2.3a1 1 0 0 0-1.4-1.4L12 10.6 9.7 8.3Z"
										clip-rule="evenodd" />
								</svg>
							</span>
							<div class="mt-4 inline whitespace-pre-line break-all">
								<span class="font-bold text-gray-700 dark:text-gray-300 overflow">Lunch poll message:</span>
								<p class="text-gray-600 dark:text-gray-300 text-sm mt-2">
									{{ lunch.message }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import settings from '@/settings';
import { formatDateTime } from '@/modules/utils';
import { useToast } from 'vue-toastification';
import lunchPlaceholderImage from '@/assets/lunch_placeholder.jpg';
import ImageChoice from '@/components/image/ImageChoice.vue';
import LunchUpdate from '@/components/lunch/LunchUpdate.vue';

export default {
	name: 'LunchDetail',
	components: { ImageChoice, LunchUpdate },
	props: ['lunchId'],
	// props: {
	// 	lunchId: {
	// 		type: Number,
	// 		required: true,
	// 	},
	// },
	data() {
		return {
			settings: settings,
			media: `${settings.backendUrl}/media/`,
			defaultImage: lunchPlaceholderImage,
			toggleImageChoice: false,
			toggleEditModal: false,
		};
	},
	computed: {
		lunch() {
			return this.$store.getters.getLunch;
		},
	},
	methods: {
		deleteLunch(lunchId) {
			if (confirm('Are you sure you want to delete this lunch?')) {
				this.$store.dispatch('DELETE_LUNCH', lunchId).catch(() => {
					this.$router.push({ name: 'lunches' });
				});
			}
		},
		closeImageChoice() {
			this.toggleImageChoice = false;
		},
		closeEditModal() {
			this.toggleEditModal = false;
		},
	},
	created() {
		const lunchId = parseInt(this.lunchId);
		this.$store.dispatch('GET_LUNCH', lunchId);
	},
	setup() {
		return { formatDateTime, toast: useToast() };
	},
};
</script>
